import { create } from 'zustand';
import { getWalletDetail, checkPaymentRetrieve } from '@/api/payment';

const reQueryWalletData = async (params?: any) => {
  const { andLoading = true } = params || {};
  
  // // 如果正在请求中，则直接返回
  // if (usePaymentStore.getState().isRequestingWallet) {
  //   return;
  // }

  // 重新进入 置空
  if (andLoading) {
    usePaymentStore.setState({ isLoadingWallet: true });
    // usePaymentStore.setState({ walletDetail: {} });
  }

  usePaymentStore.setState({ isRequestingWallet: true });  // 设置请求标志
  
  getWalletDetail().then((data) => {
    usePaymentStore.setState({ 
      walletDetail: data,
      isLoadingWallet: false,
      isRequestingWallet: false  // 重置请求标志
    });
  }).catch(() => {
    usePaymentStore.setState({ isRequestingWallet: false });  // 错误时也要重置标志
  });
}

const sendCheckPaymentRetrieve = async (params?: any) => {
  const { sessionId } = params || {};

  return checkPaymentRetrieve({ sessionId }).then((data) => {
    usePaymentStore.getState().reQueryWalletData(data);
    return data;
  }).catch(err0r => {
    // console.error("Failed to get wallet detail:", err0r);
  });
}

type PaymentStore = {
  walletDetail: any;
  setWalletDetail: (walletDetail: any) => void;
  isLoadingWallet: boolean;
  setIsLoadingWallet: (isLoadingWallet: boolean) => void;
  reQueryWalletData: (params?: { andLoading?: boolean }) => void;
  modalAddPayment: boolean;
  setModalAddPayment: (modalAddPayment: boolean) => void;
  sendCheckPaymentRetrieve: (params?: any) => Promise<any>;
  isRequestingWallet: boolean;
};

export const usePaymentStore = create<PaymentStore>((set, get) => ({
  walletDetail: null,
  setWalletDetail: (walletDetail: any) => set({ walletDetail }),
  isLoadingWallet: false,
  setIsLoadingWallet: (isLoadingWallet: boolean) => set({ isLoadingWallet }),
  reQueryWalletData,
  modalAddPayment: false,
  setModalAddPayment: (modalAddPayment: boolean) => set({ modalAddPayment }),
  sendCheckPaymentRetrieve,
  isRequestingWallet: false,
}));
